import { RotateCcw } from 'lucide-react';
import React from 'react';
import { ActionButton } from './ActionButton';
import { RetryConfirmationDialog } from './RetryConfirmationDialog';

interface ArchivedVorgangActionsProps {
  istAktuelleAbarbeitung: boolean;
  isUserAuthenticated: boolean;
  actionLoading:
    | 'retry'
    | 'delete'
    | 'save'
    | 'lock'
    | 'unlock'
    | 'restore'
    | 'zurueckstellen'
    | null;
  onRetry: () => void;
  showRetry?: boolean;
  archiveRetry?: boolean;
}

export const ArchivedVorgangActions: React.FC<ArchivedVorgangActionsProps> = ({
  istAktuelleAbarbeitung,
  isUserAuthenticated,
  actionLoading,
  onRetry,
  showRetry = true,
  archiveRetry = false,
}) => {
  const isRetryDisabled = actionLoading !== null || !isUserAuthenticated;

  if (!showRetry) return null;

  return (
    <div className="bg-white border border-table-border rounded-lg p-6">
      <h2 className="text-lg font-semibold text-text-primary mb-4">Aktionen</h2>
      <div className="flex flex-wrap gap-3">
        {istAktuelleAbarbeitung ? (
          <ActionButton
            onClick={onRetry}
            disabled={isRetryDisabled}
            loading={actionLoading === 'retry'}
            loadingText="Wird verarbeitet..."
            normalText={
              archiveRetry
                ? 'Archivierung erneut verarbeiten'
                : 'Erneut verarbeiten (Neue Abarbeitung von diesem Schritt starten)'
            }
            icon={RotateCcw}
            className="bg-blue-500 hover:bg-blue-600 text-white shadow-sm"
          />
        ) : (
          <RetryConfirmationDialog
            onRetry={onRetry}
            disabled={isRetryDisabled}
            loading={actionLoading === 'retry'}
          />
        )}
      </div>
      {archiveRetry && (
        <p className="mt-4 text-sm text-text-secondary">
          Ein bereits hochgeladenes Einzeldokument kann bei einem
          Verbindungsfehler erneut im Archiv erscheinen.
        </p>
      )}
      <p className="mt-4 text-sm text-text-secondary">
        Hinweis: Bei <strong>Erneut verarbeiten</strong> wird der Vorgang vom
        ausgewählten Schritt aus reaktiviert und aus dem Archiv in die aktive
        Liste verschoben.
      </p>
    </div>
  );
};
